import {countries} from "../countries";
import MapCountry from "./MapCountry";

interface Props {
    visited: string[]
}

function Map({visited}: Props) {

    return <svg
        id="map"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1009.6727 665.96301">
        <filter id="shadow" colorInterpolationFilters="sRGB">
            <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.1" />
        </filter>
        {countries.map(country => <MapCountry key={country.countryCode} country={country} visited={visited.includes(country.countryCode)} />)}
    </svg>
}

export default Map;
